<template>
<div>
  <el-card style="margin-bottom: 10px">
    <el-page-header  style="margin-bottom: 30px;" @back="goBack" />
    <div>
      {{pageTitle}}
    </div>
  </el-card>
  <el-card>
<!--    <el-form>-->
<!--      <el-form-item label="">-->
<!--        <el-input v-model="form.title" placeholder="输入标题"></el-input>-->
<!--      </el-form-item>-->
<!--    </el-form>-->
    <new-form ref="newForm" />
    <el-button style="margin-top: 20px" type="primary" @click="handleAdd">
      提交
    </el-button>
  </el-card>
</div>
</template>
<script>
import newForm from "./newForm/container.vue";
export default {
  data() {
    return {
      form:{
      },
      pageTitle:'新增模版'
    };
  },
  components: {
    newForm
  },
  computed: {
  },
  created() {
    this.getById()
  },
  methods: {
   async  handleAdd(){
     // console.log(this.$refs.newForm.configFormData?.list.find(item=>item.type !='text')?.name)
     // if (!this.$refs.newForm.configFormData?.list.find(item=>item.type !='text')?.name){
     //   this.$message.warning("非纯文本类型请填写右侧组件标题");
     //   return
     // }
     if (this.$route.query.id){
       this.form.id = this.$route.query.id;

       if (this.$refs.newForm.configFormData.list.length){
         this.form.forms=JSON.stringify(this.$refs.newForm.configFormData.list);
         let { data: res } = await this.$http.post("/admin/ActivityForm/edit", {
           ...this.form
         });
         if (res.errorCode==200 ){
           this.$router.push({ path: "/activity_form" });
         }
       }
     }else {
       if (this.$refs.newForm.configFormData.list.length){
         this.form.forms=JSON.stringify(this.$refs.newForm.configFormData.list);
         let { data: res } = await this.$http.post("/admin/ActivityForm/add", {
           ...this.form
         });
         if (res.errorCode==200 ){
           this.$router.push({ path: "/activity_form" });
         }
       }
     }


      // console.log(this.$refs.newForm.configFormData.list)
      // if (this.form.forms && this.$refs.newForm) {
      //   this.$refs.newForm.configFormData.list = JSON.parse(this.form.forms);
      // }
    },
    getById() {
      // console.log(this.$route.query.id);
      this.id = this.$route.query.id;
      if (this.$route.query.id) {
        this.$http.get("/admin/ActivityForm/getDetails?id=" + this.$route.query.id).then(({ data: res }) => {
          if (res.errorCode == 200) {
            // console.log('返回')
            this.form = {
              ...res.data,
            }
            this.pageTitle=res.data.title
            if (this.form.forms && this.$refs.newForm) {
              this.$refs.newForm.configFormData.list = JSON.parse(this.form.forms);
            }
          }
        });
      }
    },
    goBack() {
      this.$router.go(-1);
    },
getFormData() {
  if (this.form.forms && this.$refs.newForm) {
    this.$refs.newForm.configFormData.list = JSON.parse(this.form.forms);
  }
},
    submitForm() {
      forms: JSON.stringify(this.$refs.newForm.configFormData.list)
    }
  },
};
</script>



<style scoped lang="less">

</style>